/* eslint-env node, browser */
'use strict'
/**
 * this is a mapping of keys that require shift on a US keypad
 * back to the non shift equivelents
 *
 * this is so you can use keyup events with these keys
 *
 * note that this will only work reliably on US keyboards
 *
 * @type {Object}
 */
module.exports = {
  '~': '`',
  '!': '1',
  '@': '2',
  '#': '3',
  '$': '4',
  '%': '5',
  '^': '6',
  '&': '7',
  '*': '8',
  '(': '9',
  ')': '0',
  '_': '-',
  '+': '=',
  ':': ';',
  '"': "'",
  '<': ',',
  '>': '.',
  '?': '/',
  '|': '\\'
}



//////////////////
// WEBPACK FOOTER
// D:/agent/4/_work/121/s/common/~/combokeys/helpers/shift-map.js
// module id = 139
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///D:/agent/4/_work/121/s/common/~/combokeys/helpers/shift-map.js